import React from 'react';
import './DeleteChatModal.css';
import styles from "../tables/EmailSwapMainAPP/EmailSwapMainAPP.module.css";

const DeleteChatModal = ({isOpen, onClose, onDelete, chatId}) => {
    if (!isOpen) return null;

    return (
        <div className="delete-modal-overlay">
            <div className="delete-modal">
                <div style={{display:'flex', justifyContent:'space-between'}}>
                    <h3>Delete Chat</h3>
                    <button
                        className="delete-modal-closeButton"
                        onClick={onClose}
                    >
                        &times;
                    </button>
                </div>
                <div
                            style={{
                                width: '100%',
                                height: '1px',
                                backgroundColor: '#343434',
                                marginBottom:'37px'
                            }}
                        />
                <p>Are you sure you want to delete this chat? The action cannot be undone.</p>
                <div className="delete-modal-buttons">
                    <button
                        className="delete-modal-button cancel"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="delete-modal-button delete"
                        onClick={() => onDelete(chatId)}
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteChatModal; 